"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import r from "../components/Icon/SvgIcon.js";
const t = (e) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.869 15.744a.875.875 0 0 1-1.238 0L12 7.112l-8.631 8.632a.875.875 0 0 1-1.238-1.238l9.243-9.243a.885.885 0 0 1 1.252 0l9.243 9.243a.875.875 0 0 1 0 1.238",
        clipRule: "evenodd"
      }
    )
  }
), p = l(t);
export {
  p as ChevronUp,
  p as default
};
